export default __webpack_public_path__ + "static/media/citi.9b0bf8b0.webp";